<style type="text/css" scoped>
#revendendor:active {
  font-weight: bold;
  color: #006da5;
}

#revendedor {
  font-weight: bold;
  color: #006da5;
}

.table-responsive {
  overflow-x: auto;
}

table.ranking {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

table.ranking th,
table.ranking td {
  padding: 12px 15px;
  text-align: left;
}

table.ranking th {
  background-color: #007bff;
  color: white;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 11px;
}

table.ranking tr {
  border-bottom: 1px solid #dddddd;
}

table.ranking tr.highlight {
  background-color: #cbe5ff !important;
  font-weight: bold;
  color: #333;
}

table.ranking tr:nth-child(even) {
  background-color: #f9f9f9;
}

table.ranking tr:hover {
  background-color: #f1f1f1;
}

table.ranking td {
  color: #333;
}
</style>
<template>
  <div class="topbar-menu-area">
    <div class="container">
      <div class="topbar-menu left-menu">
        <ul>
          <li class="menu-item">
            <a title="Fale Conosco +55 (44) 3261-2000" :href="`${$SiteUrl}/institucional/faleconosco`"
              ><span class="icon label-before fa fa-mobile"></span>Fale Conosco +55 (44) 3261-2000</a
            >
          </li>
        </ul>
      </div>
      <div class="topbar-menu right-menu">
        <ul>
          <li class="menu-item" v-if="!logado"><a rel="nofollow" title="" :href="`${$SiteUrl}/login/?redirectTo=${urlRedirect}`">Entrar</a></li>
          <li class="menu-item" v-if="!logado"><a title="" id="revendedor" :href="`${$SiteUrl}/cadastro`">Seja Revendedor Aldo</a></li>
          <!-- <li class="menu-item" v-if="logado">
            <a data-toggle="modal" data-target="#myModalRanking" @click="showRankingFn" style="cursor: pointer">Olá, {{ razaoSocial }} 🎖️</a
            ><a style="color: #337ab7">{{ usuario }}</a>
          </li> -->
          <li class="menu-item" v-if="logado">
            Olá, {{ razaoSocial }} <a style="color: #337ab7">{{ usuario }}</a>
          </li>
          <li class="menu-item" v-if="logado">
            <a rel="nofollow" style="color: rgb(51, 122, 183)" :href="`${$SiteUrl}/loja/minha-conta`"
              ><i aria-hidden="true" class="fa fa-user"></i> Minha Conta</a
            >
          </li>
          <li class="menu-item" v-if="logado"><a title="" href="#" @click="logout">Logout</a></li>
        </ul>
      </div>
      <!-- <RankingClientesModal v-show="showRanking" @carregar="showRanking" /> -->
      <div id="myModalRanking" class="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title text-center"><strong>Ranking de maiores compradores</strong></h4>
            </div>
            <div class="modal-body">
              <Loader v-if="loadingRanking" />
              <div v-if="ranking.length == 0 && !loadingRanking" style="text-align: center">
                <h2>Parece que você ainda não tem pontos suficientes!</h2>
              </div>
              <div class="table-responsive">
                <table class="ranking" v-if="!loadingRanking && ranking.length > 0">
                  <thead>
                    <tr>
                      <th>Classificação</th>
                      <th>Cliente</th>
                      <th>Pontuação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="cliente in ranking" v-bind:key="cliente.Posicao" :class="{ highlight: !/^\*+$/.test(cliente.RazaoSocial) }">
                      <td style="text-align: center">{{ cliente.Posicao }}</td>
                      <td>{{ cliente.RazaoSocial }}</td>
                      <td style="text-align: right; padding-right: 40px;">{{ cliente.Pontuacao }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <div class="col-md-9">
                Promoção válida apenas para compra de geradores, conforme o regulamento.
              </div>
              <div class="col-md-3" style="float: right; padding: 0px">
                <button v-on:click="closeModalRanking()" class="btn btn-primary btn-block">FECHAR</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import RankingClientesModal from "./RankingClientesModal.vue";

export default {
  name: 'topMenu',
  components: {
    // RankingClientesModal
  },
  data() {
    return {
      logado: false,
      razaoSocial: '',
      usuario: '',
      cardHeaderInfo: '',
      urlRedirect: location.href,
      situacaoCard: 'Aldo Crazy Card - Quanto mais você compra, mais vantagens você têm!',
      crazyCardColor: '/assets/images/crazy-cards/cartao-deslogado.jpg',
      showRanking: false,
      loadingRanking: true,
      ranking: [],
    }
  },
  methods: {
    logout: function () {
      const self = this
      $.ajax({
        url: this.$apiUrl + 'Login.svc/logout',
        dataType: 'json',
        type: 'GET',
        xhrFields: { withCredentials: true },
        success: () => {
          self.logado = false
          localStorage.vendedor = 'INTERNET'
          localStorage.formaPagamento = 'vista'
          localStorage.meioPagamento = 'Boleto'
          localStorage.numCartaoBNDS = ''
          localStorage.validadeBNDS = ''
          localStorage.bandeiraBNDS = ''
          localStorage.bancoBNDS = ''
          localStorage.parcelaBNDS = ''
          localStorage.parcelaSelecionada = 'Parcelas'

          localStorage.cifKombi = ''
          localStorage.fobKombi = ''
          localStorage.cifKombiDirect = ''
          localStorage.fobKombiDirect = ''
          localStorage.removeItem('usuarioLogado')
          localStorage.removeItem('waitingLogin')

          location.href = `${self.$SiteUrl}/login`
        },
      })
    },
    loadMenu: function (session) {
      var self = this
      var plogado = false
      if (session && session.DadosCliente != null) {
        let cliente = session.DadosCliente
        plogado = true
        self.razaoSocial = cliente.CliRazaosocial.split(' ')[0]
        self.usuario = cliente.UserNome.toUpperCase()
      } else {
        plogado = false
      }
      this.logado = plogado
    },
    changeCardColor: function (c) {
      const baseUrl = '/assets/images/crazy-cards/'

      if (c.m_Item1 == 'N') {
        this.cardHeaderInfo = ' - Sem Cartão'
        if (c.m_Item2 == 'C') this.crazyCardColor = baseUrl + 'cinza-verde.jpg'
        else if (c.m_Item2 == 'B') this.crazyCardColor = baseUrl + 'cinza-amarelo.jpg'
        else if (c.m_Item2 == 'A') this.crazyCardColor = baseUrl + 'cinza-azul.jpg'
        else if (c.m_Item2 == 'N') this.crazyCardColor = baseUrl + 'cinza.jpg'
      } else if (c.m_Item1 == 'C') {
        this.cardHeaderInfo = ' - Cartão Verde'
        if (c.m_Item2 == 'N') this.crazyCardColor = baseUrl + 'verde-cinza.jpg'
        else if (c.m_Item2 == 'C') this.crazyCardColor = baseUrl + 'verde.jpg'
        else if (c.m_Item2 == 'B') this.crazyCardColor = baseUrl + 'cinza-amarelo.jpg'
        else if (c.m_Item2 == 'A') this.crazyCardColor = baseUrl + 'cinza-azul.jpg'
      } else if (c.m_Item1 == 'B') {
        this.cardHeaderInfo = ' - Cartão Amarelo'
        if (c.m_Item2 == 'N') this.crazyCardColor = baseUrl + 'amarelo-cinza.jpg'
        else if (c.m_Item2 == 'C') this.crazyCardColor = baseUrl + 'amarelo-verde.jpg'
        else if (c.m_Item2 == 'B') this.crazyCardColor = baseUrl + 'amarelo.jpg'
        else if (c.m_Item2 == 'A') this.crazyCardColor = baseUrl + 'amarelo-azul.jpg'
      } else if (c.m_Item1 == 'A') {
        this.cardHeaderInfo = ' - Cartão Azul'
        if (c.m_Item2 == 'N') this.crazyCardColor = baseUrl + 'azul-cinza.jpg'
        else if (c.m_Item2 == 'C') this.crazyCardColor = baseUrl + 'azul-verde.jpg'
        else if (c.m_Item2 == 'B') this.crazyCardColor = baseUrl + 'azul-amarelo.jpg'
        else if (c.m_Item2 == 'A') this.crazyCardColor = baseUrl + 'azul.jpg'
      }
    },
    showRankingFn: function () {
      const self = this
      $.ajax({
        url: `${this.$apiUrl}/Marketing.svc/visualizar-ranking`,
        dataType: 'json',
        type: 'GET',
        xhrFields: { withCredentials: true },
        success: (data) => {
          self.ranking = data
          self.loadingRanking = false
        },
      })
    },
    closeModalRanking: function () {
      $('#myModalRanking').modal('hide')
    },
  },
  mounted() {
    let session = JSON.parse(localStorage.getItem('usuarioLogado'))
    var self = this
    if (session == null) {
      setTimeout(function () {
        let psession = JSON.parse(localStorage.getItem('usuarioLogado'))
        if (psession) {
          self.loadMenu(psession)
        }
      }, 2000)
    } else {
      self.loadMenu(session)
    }
  },
}
</script>
